import Lightbox from 'CoreComponents/lightbox';

if (document.querySelector('.list-media__item a')) {
  new Lightbox();
}
